import Axios, { AxiosInstance, AxiosResponse, AxiosRequestConfig } from "axios";
import {  IUser } from "../model/ModelTypes";
import { isNullOrUndefined } from "util";
import { DatabaseKey, IDataStore } from "../repository/IDataStore";
import { IHttpClient } from "./IHttpClient";
import * as Raven from "raven-js";
import { IConfig } from "../IConfig";
import { Observable } from 'rxjs/Observable';
import { Observer } from "rxjs";
export class AuthenticatedHttpClient implements IHttpClient {
    private authenticateInstance: AxiosInstance;
    private user: IUser;
    private config: IConfig;
    private currentRequest: AxiosRequestConfig;
    private db: IDataStore;    
    public static GetClient(db: IDataStore, config: IConfig): Observable<IHttpClient> {
        return Observable.create( (observer: Observer<IHttpClient>) => {
           let client = new AuthenticatedHttpClient(db , config);
           let subscription = db.getDocuments<Observable<IUser>>(DatabaseKey.user)
           .first().subscribe( userObservable => {
               let secondSubcription = userObservable.first().subscribe( user => {
                
                    client.authenticateInstance.defaults.headers = {
                        "Authorization": client.createAuthHeader(user.id ? user.id : "", user.accessToken)
                    };
                    client.user = user;
                    client.addRequestInterceptor();
                    client.addResponseInterceptor();
                    observer.next(client);
               },                                                        error => {
                   observer.error(error);

               },                                                        () => {
                   secondSubcription.unsubscribe();
               });
            },                 error => {
                observer.error(error);
            },                 () => {
                subscription.unsubscribe();
            });
        });
    }
    getInstance(): AxiosInstance {
        return this.authenticateInstance;
    }
    private constructor(db: IDataStore, config: IConfig) {
        this.config = config;
        this.authenticateInstance = Axios.create();
        this.authenticateInstance.defaults.baseURL = this.config.apiBaseUrl;
        this.db = db;
    }
    
    private addRequestInterceptor() {
        this.authenticateInstance.interceptors.request.use(config => {
            if (config.url === "api/token/refresh") {
                return config;
            } else {
                this.currentRequest = config;
                return config;
            }
        });
    }
    private addResponseInterceptor() {
        this.authenticateInstance.interceptors.response.use(undefined, error => {
            let response: AxiosResponse = error.response;
            if (isNullOrUndefined(response)) {
                return Promise.reject(new Error("No internet connection"));
            }
            if (response.status === 403) {
                this.authenticateInstance.defaults.headers = {
                    "Content-Type": "application/json",
                    "Authorization": this.createAuthHeader(this.user.id ? this.user.id : "",
                                                           this.user.refreshToken ? this.user.refreshToken : "")};
                this.authenticateInstance.post(`api/token/refresh`).then( data => {
                    if (data.status === 200) {
                      let responseData: RefreshTokenResposnse = data.data;
                      if (!isNullOrUndefined(responseData.authToken) && !isNullOrUndefined(responseData.refreshToken)) {
                        this.user.accessToken = responseData.authToken;
                        this.user.refreshToken = responseData.refreshToken;
                        // Unneeded database query
                        let mergedObservable = this.db.insertDocument<IUser>(this.user, DatabaseKey.user);

                        mergedObservable.single()
                        .subscribe( undefined,
                                    observableError => {
                            return Promise.reject(observableError);
                        },          () => {
                                    this.authenticateInstance.defaults.headers = {
                                        "Content-Type": "application/json",
                                        "Authorization": this.createAuthHeader(this.user.id ? this.user.id : "", 
                                                                               this.user.accessToken)
                                    };                            
                                    return this.authenticateInstance.request(this.currentRequest);
                        });                        
                      }
                    }
                }).catch(refreshError => {
                    let refreshResponse: AxiosResponse = refreshError.response;
                    if ( refreshResponse.status === 500 && !this.config.isDebug) {
                        Raven.captureException(JSON.stringify({code: 500, 
                            error: error, 
                            function: "AuthenticatedHttpClient/addResponseInterceptor/refreshRequest",
                            response: refreshResponse}));
                        Raven.showReportDialog();
                    }
                    error.message = "User authentication faild. Please logout and login again.";
                    return Promise.reject(error);
                });
            } else {
                if ( response.status === 500 && !this.config.isDebug) {
                    if (!isNullOrUndefined(response.data) && !isNullOrUndefined(response.data.password)) {
                        delete response.data.password;
                    }
                    if (!isNullOrUndefined(response.data) && !isNullOrUndefined(response.data.password1)) {
                        delete response.data.password1;
                    }
                    if (!isNullOrUndefined(response.data) && !isNullOrUndefined(response.data.confirmPassword)) {
                        delete response.data.confirmPassword;
                    }
                    Raven.captureException(JSON.stringify({code: 500, 
                        error: error, 
                        function: "AuthenticatedHttpClient/addResponseInterceptor",
                        response: response}));
                    Raven.showReportDialog();
                }
                if (typeof response.data === "string") {
                    try {
                        response.data = JSON.parse(response.data.toString());                    
                    } catch (error) {
                        response.data = {
                            error: "Failed to execute request"
                        };
                    }
                }
                try {
                    error.message = response.data.error;
                } catch (error) {
                    error.message = "Something went wrong";
                }
                return Promise.reject(error);
            }
        });
    }

    private createAuthHeader(userId: string, token: string): string {
        return Buffer.from(JSON.stringify({id: userId, token: token})).toString("base64");
    }

}

export interface RefreshTokenResposnse {
    authToken: string;
    refreshToken: string;
}


// WEBPACK FOOTER //
// ./src/utility/AuthenticatedHttpClient.ts